export const AVAILABLE_TIMES = [
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00'
];

export interface CountryOption {
  code: string;
  label: string;
}

const COUNTRY_FALLBACK: CountryOption[] = [
  { code: 'GB', label: 'United Kingdom' },
  { code: 'IE', label: 'Ireland' },
  { code: 'FR', label: 'France' },
  { code: 'DE', label: 'Germany' },
  { code: 'ES', label: 'Spain' },
  { code: 'IT', label: 'Italy' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'US', label: 'United States' },
  { code: 'CA', label: 'Canada' },
  { code: 'AU', label: 'Australia' }
];

const buildCountryOptions = (): CountryOption[] => {
  try {
    const intl = Intl as unknown as {
      DisplayNames?: new (
        locales: string[],
        options: { type: 'region' }
      ) => { of: (code: string) => string | undefined };
      supportedValuesOf?: (key: string) => string[];
    };
    const codes = intl.supportedValuesOf?.('region');
    if (!codes || !intl.DisplayNames) return COUNTRY_FALLBACK;

    const displayNames = new intl.DisplayNames(['en'], { type: 'region' });
    return codes
      .filter((code) => /^[A-Z]{2}$/.test(code))
      .map((code) => ({ code, label: displayNames.of(code) || code }))
      .sort((a, b) => a.label.localeCompare(b.label));
  } catch (_err) {
    return COUNTRY_FALLBACK;
  }
};

export const COUNTRY_OPTIONS = buildCountryOptions();

export const getDefaultCountryCode = () => {
  if (typeof navigator === 'undefined') return 'GB';
  const locale = String(navigator.language || '');
  const match = locale.match(/-([A-Za-z]{2})$/);
  const regionCode = match ? match[1].toUpperCase() : '';
  if (regionCode && COUNTRY_OPTIONS.some((option) => option.code === regionCode)) {
    return regionCode;
  }
  return 'GB';
};
